import { memo } from 'react'

import { PartnerAdditional } from 'clickNgo/entities/partner/ui/partnerAdditional'

import { PARTNER_EDITOR_FORM_KEYS, PartnerEditorFormKeys } from '../../../configs'
import { useReadOnlyMenuItem } from '../../../hooks/useReadOnlyMenuItem'
import { PartnerFormEditableContainer } from '../../partnerFormEditableContainer/PartnerFormEditableContainer'

import { useEditPartnerAdditionalInfoHandler } from './hooks/useEditPartnerAdditionalInfoHandler'
import { IWrappedPartnerAdditionalInfoProps } from './models'

export const WrappedPartnerAdditionalInfo = memo<IWrappedPartnerAdditionalInfoProps>(
  ({ partner }) => {
    const { isCurrentMenuItemReadOnly } = useReadOnlyMenuItem()
    const { handleOnPartnerAdditionalChangesApply, handleOnPartnerAdditionalChangesCancel } =
      useEditPartnerAdditionalInfoHandler({ partner })

    return (
      <PartnerFormEditableContainer
        partner={partner}
        formKey={PartnerEditorFormKeys.AdditionalInfo}
        title={PartnerEditorFormKeys.AdditionalInfo}
        onApply={handleOnPartnerAdditionalChangesApply}
        onCancel={handleOnPartnerAdditionalChangesCancel}
      >
        <PartnerAdditional
          {...partner}
          isReadOnly={isCurrentMenuItemReadOnly}
          formKeys={PARTNER_EDITOR_FORM_KEYS}
        />
      </PartnerFormEditableContainer>
    )
  }
)
